import { memo, useMemo, type MouseEvent } from "react";

import { useCartLine } from "@shopify/hydrogen-react";

import { CartProductGiftUnassignedItemsView } from "./CartProductGiftUnassignedItems.view";

type Props = {
  handleOpenGiftWithPurchaseDrawer: (e: MouseEvent<HTMLElement>) => void;
  handlePreloadProduct: (e: MouseEvent<HTMLElement>) => void;
};

const CartProductGiftUnassignedItemsBase = ({
  handleOpenGiftWithPurchaseDrawer,
  handlePreloadProduct,
}: Props) => {
  const {
    merchandise,
    quantity: itemQuantity,
    selectedGiftsWithPurchase,
  } = useCartLine();

  const unselectedGiftWithPurchaseQuantity = useMemo(
    () => (itemQuantity ?? 0) - (selectedGiftsWithPurchase?.length ?? 0),
    [itemQuantity, selectedGiftsWithPurchase?.length]
  );

  return (
    <CartProductGiftUnassignedItemsView
      handleOpenGiftWithPurchaseDrawer={handleOpenGiftWithPurchaseDrawer}
      handlePreloadProduct={handlePreloadProduct}
      itemQuantity={itemQuantity}
      merchandise={merchandise}
      selectedGiftsWithPurchase={selectedGiftsWithPurchase}
      unselectedGiftWithPurchaseQuantity={unselectedGiftWithPurchaseQuantity}
    />
  );
};

export const CartProductGiftUnassignedItems = memo(
  CartProductGiftUnassignedItemsBase
);
